/**
 * Returns a random unique ID.
 */
export const getUniqueId = () => window.crypto.randomUUID();
